export default {
  name: "ProductImageWithFlag",
  props: {
    flag: String,
    country: String,
    childrenCount: Number
  }
};